module.exports = __webpack_public_path__ + "img/g-pm10.dc5a13ac.png";